import * as React from 'react';

import type { Stock } from '../../../output/models';

import { Link } from '../../../components/Link';
import { AllServiceLinks } from '../../../components/ServiceLink';

import { stockPath } from '../../../utils/path';

interface Props {
  stock: Stock;
}

export const StockRow: React.FC<Props> = ({ stock }) => {
  return (
    <tr>
      <td className="border border-gray p-2 text-center">{stock.code}</td>
      <td className="border border-gray p-2 text-center">
        <Link to={stockPath(stock.code)} state={{ stock }}>
          {stock.name}
        </Link>
      </td>
      <td className="border border-gray p-2 text-center">
        <div className="flex flex-wrap gap-1">
          <AllServiceLinks code={stock.code} short={true} />
        </div>
      </td>
    </tr>
  );
};
